__turbopack_context__.v({
  "secondary": "TagGroup-module__FlFN3q__secondary",
  "tag": "TagGroup-module__FlFN3q__tag",
  "tagClear": "TagGroup-module__FlFN3q__tagClear",
  "tagGroup": "TagGroup-module__FlFN3q__tagGroup",
  "tagList": "TagGroup-module__FlFN3q__tagList",
  "tagUnselectable": "TagGroup-module__FlFN3q__tagUnselectable",
});
